import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { LOCKBOX_BADGE_TOOLTIP_CLASS } from "./NeedsLockboxBadge";

export const NoLockboxBadge = ({ className }: { className?: string }) => {
  const { unit } = useUnitsPropertiesDictionary();

  return (
    <Badge
      variant={BadgeVariant.BASE}
      size={BadgeSize.SM}
      className={className}
      tooltip={`Leads get this ${unit}'s entry instructions instead of a lockbox code.`}
      tooltipClassName={LOCKBOX_BADGE_TOOLTIP_CLASS}
      placement="bottom"
    >
      No lockbox
    </Badge>
  );
};
